<template>
    <div v-if="loaded" class="navbar-end">
        <div class="navbar-item navbar-user" v-if="!isLoggedIn">
            <!-- login button -->
            <div v-if="loginAllowed" class="navbar-button-block">
                <router-link :to="{ name: 'login' }" class="button">
                    <span class="icon">
                        <i class="fas fa-sign-in-alt"></i>
                    </span>
                    <span>{{"components.common.topbar.login" | translate}}</span>
                </router-link>
            </div>
            <!-- registration button -->
            <div v-if="registrationAllowed" class="navbar-button-block">
                <router-link :to="{ name: 'registration' }" class="button">
                    <span class="icon">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>{{"components.common.topbar.sign up" | translate}}</span>
                </router-link>
            </div>
        </div>

        <div class="navbar-user-info" v-if="isLoggedIn">
            <router-link
                :to="{ name: 'profile', hash: '#balance' }"
                class="navbar-balance"
                :class="{ 'extended' : player.balance.bonus > 0}"
                active-class
            >
                <div v-if="player.balance" class="navbar-balance-inner">
                    <div class="navbar-balance-wrapper">
                        <span class="navbar-balance--balance">
                            {{ player.balance.real | currency(player.balance.currency) }}
                        </span>
                        <template v-if="player.balance.bonus > 0">
                            &#x20; / &#x20;
                            <span class="navbar-balance--bonus">
                                {{ player.balance.bonus | currency(player.balance.currency) }}
                            </span>
                        </template>
                    </div>
                </div>
                <span v-else class="navbar-balance-inner">0</span>
            </router-link>

            <router-link
                v-if="player.balance && (client.paymentSystem.paymentSystemDepositAllowed || client.paymentSystem.pinDepositAllowed)"
                class="button navbar-deposit"
                :to="{ name: 'profile', hash: '#deposit' }"
                active-class
            >{{"components.common.topbar.deposit" | translate}}</router-link>
        </div>

        <!-- lang -->
        <div v-if="!isMobile && availableLanguages.length > 1" class="navbar-item has-dropdown is-hoverable languages-block">
            <a class="navbar-link">
                <span class="icon">
                    <i class="fas fa-globe" aria-hidden="true"></i>
                </span>
                <span>{{langDescriptions[lang]}}</span>
            </a>
            <div class="navbar-dropdown is-right">
                <a v-for="l in availableLanguages" class="navbar-item" @click="lang=l" :key="l">
                    <span>{{langDescriptions[l]}}</span>
                </a>
            </div>
        </div>

        <!-- timezone -->
        <!--
        <div v-if="isMobile" class="navbar-item">
            <div class="field">
                <div class="field-label is-normal">
                    <label class="label">{{"components.common.topbar.timezone" | translate}}</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <div class="select">
                                <select v-model="timezone">
                                    <option v-for="tz in timezones" :key="tz.id" :value="tz">{{tz.description}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->
        
        <!-- mobile icon instruction -->
        <div class="navbar-item" v-if="isMobile && client.view.mobile.mobileIconInstruction">
            <router-link
                :to="{name: 'mobile-icon-instruction'}"
                class="button is-success is-outlined"
            >
                <span>{{"components.common.topbar.mobile icon" | translate}}</span>
                <span class="icon">
                    <i class="fab fa-android fa-lg"></i>
                </span>
                <span class="icon">
                    <i class="fab fa-apple fa-lg"></i>
                </span>
            </router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';
import menuHelper from '../../../helpers/menu.helper';

export default {
    name: 'topbar-end',
    data() {
        return {
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet,
            historyRoute: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        loginAllowed() {
            return this.client && this.client.login.loginTypes && this.client.login.loginTypes.length;
        },
        registrationAllowed() {
            return this.client && this.client.registration.registrationTypes && this.client.registration.registrationTypes.length;
        },
        player() {
            return Vue.state.player.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang: {
            get() {
                return Vue.state.lang.currentLang;
            },
            set(val) {
                Vue.state.lang.currentLang = val;
            }
        },
        availableLanguages() {
            return Vue.state.lang.availableLanguages;
        },
        langDescriptions() {
            return Vue.state.lang.langDescriptions;
        },
        timezones() {
            return Vue.state.timezones.get();
        },
        timezone: {
            get() {
                return Vue.state.currentTimezone.get();
            },
            set(val) {
                Vue.state.currentTimezone.set(val);
            }
        }
    },
    async created() {
        await Vue.state.client.ensure();
        await Vue.state.player.ensure();

        let historyLinks = await menuHelper.getHistoryLinks();
        if (historyLinks.length) this.historyRoute = historyLinks[0].route;

        this.loaded = true;
    },
    mounted() {
        this.lang = this.availableLanguages.find(item => item === this.lang) || this.availableLanguages[0]
    },
    methods: {
        openLogout() {
            Vue.state.modals.openLogoutModal().then(
                async () => {
                    await Vue.router.teleport.home();
                },
                () => {}
            );
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-end.vue